<template>
  <div class="shipping-proparts">
    <CustomTitle :title="mytitle"/>
    <div class="table-header df-c">
      <span class="index">#</span>
      <span class="PartNu" style="">工号</span>
      <span class="overflow-text">下单</span>
      <span class="overflow-text">厂内交期</span>

      <span class="overflow-text" v-if="isShowPo === '1'" style="flex:1.7" >客户PO</span>
      <span class="overflow-text" v-if="isShowMo === '1'" style="flex:1.7;text-align:center" >机型规格</span>
      <span class="overflow-text" style="flex:1.7;text-align:center" >图号</span>
      <span class="overflow-text" style="flex:1.7;text-align:center" >工件名称</span>
      <!-- <span class="overflow-text" style="flex:1.7;text-align:center" >描述</span> -->
      <span class="overflow-text" style="flex:1.7;text-align:right" >材质</span>
      <span class="overflow-text" style="flex:1;text-align:right" >数量</span>
      <span class="overflow-text" style="flex:1;text-align:right" >单位</span>
      <span class="overflow-text" style="flex:1.7;text-align:right" >备注</span>
      <span class="overflow-text"
        style="flex:1.7;text-align:center"
      >特急</span>
      <span class="overflow-text" style="flex:1.7;text-align:center" >产品类型</span>
      <span class="overflow-text" style="flex:1.7;text-align:center" >工艺</span>
      <span class="overflow-text" style="flex:1.7;text-align:center" >部门</span>
      <span class="overflow-text" style="flex:1.7;text-align:center" >加工者</span>
      <span class="overflow-text" style="flex:1.7;text-align:center" >状态</span>




    </div>
    <div class="scroll-chart">
      <vue-seamless-scroll :data="tableData" class="warp" :class-option="classOption">
        <template v-for="(item, index) in tableData" >
          <div class="table-item df-c" :key="index" ref="TableItem">
            <span class="index">{{index+1}}</span>
            <span class="PartNu" style="">{{item.PartNu}}</span>
            <span class="overflow-text">{{echoTime(item.ProTime)}}</span>
            <span
              class="overflow-text"
              :style="{color:echoColor(item.FinDate)}"
            >{{echoTime(item.FinDate)}}</span>
            <span class="overflow-text" v-if="isShowPo === '1'" style="flex:1.7" :title="item.PO">
              {{item.PO}}</span>
            <span class="overflow-text" v-if="isShowMo === '1'" style="flex:1.7;text-align:center" :title="item.MouldName">{{item.MouldName?item.MouldName.substr(-13):item.MouldName}}</span>
            <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.PartTitle">{{item.PartTitle?item.PartTitle.substr(-13):item.PartTitle}}</span>
            <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.PartNumber">{{item.PartNumber?item.PartNumber.substr(-13):item.PartNumber}}</span>
            <!-- <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.PartDesc">{{item.PartDesc?item.PartDesc.substr(-13):item.PartDesc}}</span> -->
            <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.Material">{{item.Material?item.Material.substr(-13):item.Material}}</span>
            <span class="overflow-text" style="flex:1;text-align:center" :title="item.ProSet">{{item.ProSet}}</span>
            <span class="overflow-text" style="flex:1;text-align:center" :title="item.ProPcs">{{item.ProPcs}}</span>
            <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.DETAIL1">{{item.DETAIL1?item.DETAIL1.substr(-13):item.DETAIL1}}</span>
             <span
              class="overflow-text"
              :style="{color:item.Precedence=='急件'?'#FBCF5B':'#FFA8B6'}"
            >{{item.Precedence}}</span>
            <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.PartKindStr">{{item.PartKindStr}}</span>
            <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.DeptTec">{{item.DeptTec}}</span>
            <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.CurDEP">{{item.CurDEP}}</span>
            <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.CurProcesser">{{item.CurProcesser}}</span>
            <span class="overflow-text" style="flex:1.7;text-align:center" :title="item.StatusStr">{{item.StatusStr}}</span>


          </div>
        </template>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import CustomTitle from '@/components/CustomTitle'
import vueSeamlessScroll from 'vue-seamless-scroll'
import config from '@/js/config'
import moment from 'moment'
export default {
  name: 'ShippingProParts',
  data () {
    return {
      compid: -1,
      dept: '',
      mytitle:"加工中工号列表",
      tableHeader: [
        '工号',
        '客户PO',
        '模号',
        '特急',
        '下单日期',
        '厂内交期',
        '生管交期',
        '总款数',
        '未完款数',
        // '总件数',
        // '未完件数',
        '备注'
      ],
      tableData: [],
      classOption: {
        step: 8,//0.5
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 0

      },
      requestTimer: null,
      isShowPo: '',
      isShowMo: '1',
      isBusy:'',
      nowDay: moment().format('YYYY-MM-DD'),
      afterThreeDay: moment().add(2, 'days').format('YYYY-MM-DD'),
      requestUrl:'',
      retryTimer: null // 重试延时器
    }
  },
  methods: {
    getPOparts () {
      clearTimeout(this.retryTimer)
      //
        this.compid = window.localStorage.getItem('bsmcompid')
        this.dept = window.localStorage.getItem('bsmdept')
      //}
      this.isShowPo = window.localStorage.getItem('isShowPo')
      this.isShowMo = window.localStorage.getItem('isShowMo')
      this.isBusy = window.localStorage.getItem('bsmisBusy')
      if(this.isBusy=="1")
      {
        this.classOption.step=8;
      }

      var pa = {
        datekind: 0,
        dst: '',
        ded: '',
        compid: this.compid,
        status:-1
      }
      this.axios({
        method: 'post',
        // params: pa,
        //url: '/admin.php/Bigsreen/SalepropoFun'
        url: this.requestUrl+'/admin.php/Bigsreen/SalePartlistFun?datekind=0&status=-1&compid='+this.compid+'&dst=&ded='
      })
        .then((Response) => {
          var data = JSON.parse(Response.data)
          // console.log(data)
          var headtxt=data['head']
          var hearr=[];
          var hearrwith=[];

          headtxt.forEach(h1 => {
            var hh= h1.split(',')
            var txt=hh[0];


            hearr.push(hh[0]);
            if(hh.length>1)
            {
              var wi=Math.trunc(hh[1]);
              var kk=(hh[1]-wi)*1000;
              var hid=0;



              hearrwith.push([wigth=>wi]);

            }
            else
            {

            }
            //console.log(hh)
          });
          //console.log(hearr)
          this.tableHeader=hearr;
          // 登录未勾选po
          if (this.isShowPo === '2' || !this.isShowPo) {
            this.tableHeader = this.tableHeader.filter(
              (item) => item !== '客户PO'
            )
          }
          // 登录未勾选mo
          if (this.isShowMo === '2' || !this.isShowMo) {
            this.tableHeader = this.tableHeader.filter(
              (item) => item !== '模号'
            )
          }
          // console.log(this.tableData )
          this.tableData = data['rows']
          //console.log(data['rows'])
        })
        .catch((error) => {
          // 异常30s进行重试
          console.log(error+" ShippingSchedule")
          this.retryTimer = setTimeout(() => {
            this.getPOparts()
          }, config.retryTime)
        })
    },
    // 回显日期
    echoTime (time) {
      if (time) {
        // time=time.replaceAll("/","-");
        var timeArr = time.split('-')
        return timeArr[1] + '-' + timeArr[2]
      }
      return ''
    },
    // 回显颜色
    echoColor (time) {
      if (!time) {
        return '#fff'
      }
      if (time < this.nowDay) {
        return '#FFA8B6'
      }
      if (time >= this.nowDay && time <= this.afterThreeDay) {
        return '#FBCF5B'
      }
      return '#fff'
    }
  },
  created () {
    this.requestUrl=window.localStorage.getItem('requestUrl')
    this.getPOparts()
  },
  mounted () {
    this.requestTimer = setInterval(() => {
      this.getPOparts()
    }, config.refreshTime.shippingSchedule)
  },
  beforeDestroy () {
    clearInterval(this.requestTimer)
    clearTimeout(this.retryTimer)
  },
  components: {
    CustomTitle,
    vueSeamlessScroll
  },
  watch: {}
}
</script>

<style scoped lang="less">
.shipping-proparts {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px 8px !important;
  .table-header {
    margin-top: 8px;
    background: linear-gradient(0deg, #1b6787 -24.83%, #4aaef7 100%);
    padding: 0 16px;
    border-radius: 8px 8px 0px 0px;
    .index {
      width: 30px;
      flex: unset;
    }
    span {
      flex: 1;
      padding: 7px 2px;
      text-align: center;
      // height: 22px;
      font-family: 'PingFang SC';
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
      &:nth-child(2){
        flex: 1.7 !important;
      }
    }
  }
  .table-item {
    cursor: pointer;
    padding: 0 16px;
    .index {
      width: 30px;
      flex: unset;
    }
    .PartNu{
      width: 80px;
      flex: unset;
    }
    span {
      flex: 1;
      padding: 5px 2px;
      text-align: center;
      // height: 22px;
      font-family: 'PingFang SC';
      font-weight: 500;
      font-size: 16px;
      //font-size: 14px;
      line-height: 22px;
      color: #bae3e6;
      &:nth-child(2){
        flex: 1.7 !important;
      }
    }
  }

  .scroll-chart {
    flex: 1;
    // height: 0;
    min-height: 100px;
    overflow: hidden;
    border: 1px solid #2dcdff;
    border-top: 0;
    border-radius: 0px 0px 8px 8px;
    .warp {
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/components/ShippingProParts.vue